<template>
  <svg
    width="10"
    height="12"
    viewBox="0 0 10 12"
  >
    <path d="M2.49998 1H3V4.68895C3 5.13159 2.88248 5.56629 2.65944 5.94863L0.445378 9.74413C-0.137951 10.7441 0.583355 11.9999 1.74104 11.9999H8.25895C9.41664 11.9999 10.1379 10.7441 9.55462 9.74413L7.34056 5.94863C7.11752 5.56629 7 5.13159 7 4.68895V1H7.49998C7.77613 1 7.99998 0.776142 7.99998 0.5C7.99998 0.223858 7.77613 0 7.49998 0H2.49998C2.22384 0 1.99998 0.223858 1.99998 0.5C1.99998 0.776142 2.22384 1 2.49998 1ZM4 4.68895V1H6V4.68895C6 5.30864 6.16453 5.91723 6.47678 6.45251L6.79615 7H3.20384L3.52322 6.45251C3.83547 5.91723 4 5.30864 4 4.68895ZM2.62051 8H7.37949L8.69084 10.248C8.88529 10.5813 8.64485 10.9999 8.25895 10.9999H1.74104C1.35515 10.9999 1.11471 10.5813 1.30916 10.248L2.62051 8Z" />
  </svg>
</template>
